export const ViewStyleNames = {
  home: 'view_style_home',
  channel: 'view_style_channel',
  downloads: 'view_style_downloads',
  playlist: 'view_style_playlist',
};

export const ViewStyles = {
  grid: 'grid',
  list: 'list',
};
